import ApiService from "@/services/api.service";

export const GET_WIDGETS = "getWidgets";
export const GET_ALERT_WIDGETS = "getAlertWidgets";
export const EXPORT_REPORT = "exportReport";

export const SET_LIST_WIDGETS = "setListWidgets";
export const SET_LIST_ALERT_WIDGETS = "setListAlertWidgets";
export const SET_DOWNLOADING = "setDownloading";
export const SET_CLIENT = "setClient";
export const SET_ERROR = "setError";

const state = {
    error: {},
    listWidgets: [],
    listAlertWidgets: [],
    downloading: false,
    idCliente: null,
};

const getters = {
    listWidgets: (state) => state.listWidgets,
    downloading: (state) => state.downloading,
    idCliente: (state) => state.idCliente,
};

const actions = {
    [GET_WIDGETS](context, query) {
        context.state.listWidgets.length = 0;
        return new Promise((resolve) => {
            ApiService.get(`Dashboard/widgetFatturazione?${query}`)
                .then(({ data }) => {
                    context.commit(SET_LIST_WIDGETS, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        context.commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    }
                });
        });
    },

    [GET_ALERT_WIDGETS](context) {
        context.state.listAlertWidgets.length = 0;
        return new Promise((resolve) => {
            ApiService.get(`Dashboard/widgetAlert`)
                .then(({ data }) => {
                    context.commit(SET_LIST_ALERT_WIDGETS, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        context.commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    }
                });
        });
    },

    [EXPORT_REPORT]({ commit }, { idBanca, year, month }) {
        commit(SET_DOWNLOADING, true);
        return new Promise((resolve) => {
            ApiService.generate(
                `Fatturazione/ReportMensileBancaSenzaRicalcolo/${idBanca}/${year}/${month}`
            )
                .then((res) => {
                    // window.open(fileURL);
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(res.data);
                    link.target = "_blank";
                    link.download = `Fatturazione-${idBanca}/${year}/${month}`;
                    document.body.appendChild(link);
                    link.click();
                    commit(SET_DOWNLOADING, false);

                    resolve(res.data);
                })
                .catch(({ response }) => {
                    if (response) {
                        commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => {
                            commit(SET_ERROR, "");
                            commit(SET_DOWNLOADING, false);
                        }, 5000);
                    }
                });
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_LIST_WIDGETS](state, widgets) {
        state.listWidgets.push(...widgets);
    },
    [SET_LIST_ALERT_WIDGETS](state, widgets) {
        state.listAlertWidgets.push(...widgets);
    },
    [SET_DOWNLOADING](state, val) {
        state.downloading = val;
    },
    [SET_CLIENT](state, val) {
        state.idCliente = val;
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
